document.addEventListener('DOMContentLoaded', function () {
  const videoCarousel = document.querySelector('.cus-video-carousel');
  const arrowLeft = document.querySelector('.cus-arrow-left');
  const arrowRight = document.querySelector('.cus-arrow-right');
  const videoContainers = document.querySelectorAll('.cus-video-container');
  const videos = document.querySelectorAll('[data-video-element]');
  const playButtons = document.querySelectorAll('.cus-play-button');
  const muteButtons = document.querySelectorAll('[data-mute-button]');
  const videoItems = document.querySelectorAll('.cus-video-item');
  const cartButtons = document.querySelectorAll('[data-cart-button]');
  const modal = document.getElementById('video-caro-modal');
  const modalContent = document.getElementById('video-caro-modal-content');
  const modalClose = modal.querySelector('.video-caro-modal-close');
  const lazyImages = document.querySelectorAll('.cus-video-poster[data-src]');
  const productImages = document.querySelectorAll('.video-caro-product-image[data-src]');

  const playIconPath = '<path d="M187.2 100.9C174.8 94.1 159.8 94.4 147.6 101.6C135.4 108.8 128 121.9 128 136L128 504C128 518.1 135.5 531.2 147.6 538.4C159.7 545.6 174.8 545.9 187.2 539.1L523.2 355.1C536 348.1 544 334.6 544 320C544 305.4 536 291.9 523.2 284.9L187.2 100.9z"/>';
  const pauseIconPath = '<path d="M5.5 4.5A.5.5 0 0 1 6 4h1.5a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-11zm4 0a.5.5 0 0 1 .5-.5H12a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-11z"/>';

  function initVideoLazyLoading() {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const video = entry.target;
          const videoId = video.dataset.videoId;
          const videoElement = document.querySelector(`[data-video-element][data-video-id="${videoId}"]`);
          
          if (videoElement && videoElement.dataset.loaded === 'false') {
            const src = videoElement.dataset.src;
            const poster = videoElement.dataset.poster;
            
            if (src) {
              const source = document.createElement('source');
              source.src = src;
              source.type = 'video/mp4';
              videoElement.appendChild(source);
              videoElement.dataset.loaded = 'true';
            }
            
            if (poster && videoElement.poster !== poster) {
              videoElement.poster = poster;
            }
            
            videoObserver.unobserve(video);
          }
        }
      });
    }, {
      rootMargin: '100px',
      threshold: 0.1
    });

    videoContainers.forEach(container => {
      videoObserver.observe(container);
    });
  }

  function initImageLazyLoading() {
    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
            imageObserver.unobserve(img);
          }
        }
      });
    }, {
      rootMargin: '100px',
      threshold: 0.1
    });

    lazyImages.forEach(img => imageObserver.observe(img));
    productImages.forEach(img => imageObserver.observe(img));
  }

  function preloadVideosInViewport() {
    const carouselRect = videoCarousel.getBoundingClientRect();
    const preloadMargin = 200;
    
    videoContainers.forEach(container => {
      const itemRect = container.getBoundingClientRect();
      const isInView = itemRect.right > (carouselRect.left - preloadMargin) && 
                      itemRect.left < (carouselRect.right + preloadMargin);
      
      if (isInView) {
        const video = container.querySelector('video[data-video-element]');
        if (video && video.dataset.loaded === 'false') {
          const src = video.dataset.src;
          const poster = video.dataset.poster;
          
          if (src) {
            const source = document.createElement('source');
            source.src = src;
            source.type = 'video/mp4';
            video.appendChild(source);
            video.dataset.loaded = 'true';
          }
          
          if (poster && video.poster !== poster) {
            video.poster = poster;
          }
        }
      }
    });
  }

  function loadAndPlayVideo(video) {
    if (video.dataset.loaded === 'false') {
      const src = video.dataset.src;
      const poster = video.dataset.poster;
      
      if (src) {
        const source = document.createElement('source');
        source.src = src;
        source.type = 'video/mp4';
        video.innerHTML = '';
        video.appendChild(source);
        video.load();
        video.dataset.loaded = 'true';
      }
      
      if (poster && video.poster !== poster) {
        video.poster = poster;
      }
    }
  }

  videos.forEach((video) => {
    video.pause();
    video.currentTime = 0;
  });

  function scrollToNextItem(direction) {
    const firstItem = videoItems[0];
    if (!firstItem) return;

    const itemWidth = firstItem.offsetWidth;
    const gap = parseInt(getComputedStyle(videoCarousel).gap) || 25;
    const scrollAmount = itemWidth + gap;

    let scrollPosition = videoCarousel.scrollLeft;
    const maxScroll = videoCarousel.scrollWidth - videoCarousel.clientWidth;

    if (direction === 'left') {
      scrollPosition = Math.max(0, scrollPosition - scrollAmount);
    } else {
      scrollPosition = Math.min(maxScroll, scrollPosition + scrollAmount);
    }

    videoCarousel.scrollTo({
      left: scrollPosition,
      behavior: 'smooth',
    });

    setTimeout(() => {
      updateArrowVisibility();
      preloadVideosInViewport();
    }, 300);
  }

  arrowLeft.addEventListener('click', () => scrollToNextItem('left'));
  arrowRight.addEventListener('click', () => scrollToNextItem('right'));

  function updateArrowVisibility() {
    const scrollLeft = videoCarousel.scrollLeft;
    const maxScroll = videoCarousel.scrollWidth - videoCarousel.clientWidth;

    arrowLeft.style.opacity = scrollLeft > 10 ? '1' : '0';
    arrowLeft.style.visibility = scrollLeft > 10 ? 'visible' : 'hidden';

    arrowRight.style.opacity = scrollLeft < maxScroll - 10 ? '1' : '0';
    arrowRight.style.visibility = scrollLeft < maxScroll - 10 ? 'visible' : 'hidden';
  }

  videoCarousel.addEventListener('scroll', () => {
    requestAnimationFrame(() => {
      updateArrowVisibility();
      pauseHiddenVideos();
      preloadVideosInViewport();
    });
  });

  function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
  }

  muteButtons.forEach((button, index) => {
    const video = videos[index];
    const muteIcon = button.querySelector('.mute-icon');
    const unmuteIcon = button.querySelector('.unmute-icon');

    button.addEventListener('click', function (e) {
      e.stopPropagation();

      video.muted = !video.muted;

      if (video.muted) {
        button.classList.remove('active');
        muteIcon.style.display = 'block';
        unmuteIcon.style.display = 'none';
      } else {
        button.classList.add('active');
        muteIcon.style.display = 'none';
        unmuteIcon.style.display = 'block';
      }
    });

    if (!video.muted) {
      button.classList.add('active');
      muteIcon.style.display = 'none';
      unmuteIcon.style.display = 'block';
    }
  });

  cartButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      e.stopPropagation();

      const videoItem = this.closest('.cus-video-item');
      if (videoItem && videoItem.classList.contains('playing')) {
        const video = videoItem.querySelector('video');
        if (video && !video.paused) {
          video.pause();
          videoItem.classList.remove('playing');
          const playIcon = videoItem.querySelector('.cus-play-button svg');
          if (playIcon) playIcon.innerHTML = playIconPath;
        }
      }

      const template = document.querySelector(`[data-product-template="${this.dataset.cartButton}"]`);
      if (template) {
        modalContent.innerHTML = template.innerHTML;
        
        const productImage = modalContent.querySelector('.video-caro-product-image[data-src]');
        if (productImage && productImage.dataset.src) {
          productImage.src = productImage.dataset.src;
          productImage.removeAttribute('data-src');
        }
        
        modal.classList.add('active');
      }
    });
  });

  modalClose.addEventListener('click', function () {
    modal.classList.remove('active');
  });

  modal.addEventListener('click', function (e) {
    if (e.target === modal) {
      modal.classList.remove('active');
    }
  });

  function setupTouchDevicePlayback() {
    videoItems.forEach((item, index) => {
      const video = videos[index];
      const container = item.querySelector('.cus-video-container');
      const playButton = playButtons[index];
      const playIcon = playButton.querySelector('svg');

      playButton.addEventListener('touchstart', function (e) {
        e.stopPropagation();
        e.preventDefault();

        loadAndPlayVideo(video);
        video.style.display = 'block';

        video.play().then(() => {
          item.classList.add('playing');
          playIcon.innerHTML = pauseIconPath;
        }).catch((error) => {
          console.error('Mobile playback error:', error);
        });
      });

      playButton.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();

        loadAndPlayVideo(video);
        video.style.display = 'block';
        video.play().then(() => {
          item.classList.add('playing');
          playIcon.innerHTML = pauseIconPath;
        });
      });

      container.addEventListener('click', function (e) {
        if (
          !e.target.closest('.cus-play-button') &&
          !e.target.closest('.cus-mute-button') &&
          !e.target.closest('.video-caro-cart-button')
        ) {
          if (!video.paused) {
            video.pause();
            item.classList.remove('playing');
            playIcon.innerHTML = playIconPath;
          }
        }
      });
    });
  }

  function setupDesktopPlayback() {
    videoItems.forEach((item, index) => {
      const video = videos[index];
      const container = item.querySelector('.cus-video-container');
      const playButton = playButtons[index];
      const playIcon = playButton.querySelector('svg');

      container.addEventListener('mouseenter', function () {
        if (video.paused && !item.classList.contains('ended')) {
          loadAndPlayVideo(video);
          video.style.display = 'block';
          video.play().catch((e) => console.log('Play error:', e));
          item.classList.add('playing');
          playIcon.innerHTML = pauseIconPath;
        }
      });

      container.addEventListener('mouseleave', function () {
        if (!video.paused && !item.classList.contains('ended')) {
          video.pause();
          item.classList.remove('playing');
          playIcon.innerHTML = playIconPath;
        }
      });

      container.addEventListener('click', function (e) {
        if (
          e.target.closest('.cus-play-button') ||
          e.target.closest('.cus-mute-button') ||
          e.target.closest('.video-caro-cart-button')
        ) {
          return;
        }

        if (video.paused) {
          loadAndPlayVideo(video);
          video.style.display = 'block';
          video.play().catch((e) => console.log('Play error:', e));
          item.classList.add('playing');
          item.classList.remove('ended');
          playIcon.innerHTML = pauseIconPath;
        } else {
          video.pause();
          item.classList.remove('playing');
          playIcon.innerHTML = playIconPath;
        }
      });
    });
  }

  function setupCommonPlayback() {
    playButtons.forEach((button, index) => {
      const video = videos[index];
      const item = videoItems[index];
      const playIcon = button.querySelector('svg');

      button.addEventListener('click', function (e) {
        if (video.paused) {
          loadAndPlayVideo(video);
          video.style.display = 'block';
          video.play().catch((e) => console.log('Play error:', e));
          item.classList.add('playing');
          item.classList.remove('ended');
          playIcon.innerHTML = pauseIconPath;
        } else {
          video.pause();
          item.classList.remove('playing');
          playIcon.innerHTML = playIconPath;
        }
      });
    });

    videos.forEach((video, index) => {
      const item = videoItems[index];
      const playIcon = playButtons[index].querySelector('svg');

      video.addEventListener('play', function () {
        item.classList.add('playing');
        item.classList.remove('ended');
        playIcon.innerHTML = pauseIconPath;
      });

      video.addEventListener('ended', function () {
        item.classList.add('ended');
        item.classList.remove('playing');
        playIcon.innerHTML = playIconPath;
      });
    });
  }

  function pauseHiddenVideos() {
    const carouselRect = videoCarousel.getBoundingClientRect();

    videos.forEach((video, index) => {
      const item = videoItems[index];
      const itemRect = item.getBoundingClientRect();

      const isVisible = itemRect.right > carouselRect.left + 50 && itemRect.left < carouselRect.right - 50;

      if (!isVisible && !video.paused) {
        video.pause();
        item.classList.remove('playing');
        const playIcon = playButtons[index].querySelector('svg');
        if (playIcon) playIcon.innerHTML = playIconPath;
      }
    });
  }

  function handleAddToCart(variantId, button) {
    if (!variantId) {
      console.error('Product variant ID missing');
      return;
    }

    const originalText = button.innerHTML;
    button.innerHTML = 'Adding...';
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
    })
      .then((res) => {
        if (!res.ok) throw new Error();
        document.dispatchEvent(new Event('cart:refresh'));
        button.innerHTML = 'Added!';
        setTimeout(() => {
          button.innerHTML = originalText;
          button.disabled = false;
        }, 2000);
      })
      .catch(() => {
        alert('Error adding to cart');
        button.innerHTML = originalText;
        button.disabled = false;
      });
  }

  function handleBuyNow(variantId, button) {
    if (!variantId) {
      console.error('Product variant ID missing');
      return;
    }

    const originalText = button.innerHTML;
    button.innerHTML = 'Processing...';
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
    })
      .then((res) => {
        if (res.ok) {
          window.location.href = '/checkout';
        } else {
          throw new Error();
        }
      })
      .catch(() => {
        alert('Error adding to cart');
        button.innerHTML = originalText;
        button.disabled = false;
      });
  }

  modalContent.addEventListener('click', function (e) {
    const addCartButton = e.target.closest('.video-caro-add-cart-button');
    const buyNowButton = e.target.closest('.video-caro-buy-now-button');

    if (addCartButton) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = addCartButton.getAttribute('data-product-variant-id');
      handleAddToCart(variantId, addCartButton);
      return;
    }

    if (buyNowButton) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = buyNowButton.getAttribute('data-product-variant-id');
      handleBuyNow(variantId, buyNowButton);
      return;
    }
  });

  initVideoLazyLoading();
  initImageLazyLoading();
  updateArrowVisibility();

  if (isTouchDevice()) {
    setupTouchDevicePlayback();
  } else {
    setupDesktopPlayback();
  }

  setupCommonPlayback();

  window.addEventListener('resize', function () {
    setTimeout(() => {
      updateArrowVisibility();
      pauseHiddenVideos();
      preloadVideosInViewport();
    }, 250);
  });

  setTimeout(() => {
    preloadVideosInViewport();
  }, 500);
});